import { ReactNode, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect';

type Props = {
  children: ReactNode;
  id?: string;
  className?: string;
  prepend?: boolean;
};

export function Portal({ children, id, className, prepend }: Props) {
  const node = useMemo(
    () =>
      // document does not exist in Hypernova
      global.document?.createElement('div'),
    [],
  );

  if (node) {
    node.id = id || '';
    node.className = className || '';
  }

  useIsomorphicLayoutEffect(() => {
    if (!node) return undefined;

    const container = document.getElementById('layout-root') || document.body;

    if (prepend) {
      container.prepend(node);
    } else {
      container.appendChild(node);
    }

    return () => {
      container.removeChild(node);
    };
  }, [node, prepend]);

  return node ? createPortal(children, node) : null;
}
